import React from 'react'
import { useAppDispatch } from '@SonarCX/hooks/redux'

import Signal from '@SonarCX/lib/signal'
import { addEmail } from '@SonarCX/slices/extensionAPI'

type MessageType = {
  type: 'email'
  data: any
}

const ExtensionAPIProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const dispatch = useAppDispatch()

  // Wait for signal to update
  React.useEffect(() => {
    const handleExtensionMessage = async (message: MessageType) => {
      const { type, data } = message

      if (type === 'email') {
        dispatch(addEmail(data))
      }
    }

    window.SONAR_SIGNAL.on(Signal.extension, handleExtensionMessage)

    return () => {
      window.SONAR_SIGNAL.off(Signal.extension, handleExtensionMessage)
    }
  }, [dispatch])

  // Handle post message from chrome extension
  React.useEffect(() => {
    const handleExtensionMessage = async (event: MessageEvent) => {
      if (event.data?.type === 'extension') {
        window.SONAR_SIGNAL.signal(Signal.extension, event.data.payload)
      }
    }

    window.addEventListener('message', handleExtensionMessage)

    return () => {
      window.removeEventListener('message', handleExtensionMessage)
    }
  }, [dispatch])

  return <>{children}</>
}

export default ExtensionAPIProvider
